import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 28 28"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M14.53 6.802a2.625 2.625 0 0 0-1.06 0c-.362.076-.722.265-1.765.845L4.434 11.69l6.947 4.634c1.179.786 1.59 1.044 2.008 1.144.403.097.823.097 1.225 0 .418-.1.829-.358 2.01-1.145l6.946-4.633-7.273-4.043c-1.042-.58-1.403-.77-1.767-.845M13.12 5.09a4.375 4.375 0 0 1 1.764 0c.659.136 1.267.473 2.146.963l.117.066 8.526 4.739a.875.875 0 0 1 .45.764v8.19c0 .95 0 1.715-.051 2.333-.051.639-.162 1.198-.426 1.716a4.376 4.376 0 0 1-1.912 1.913c-.518.263-1.078.373-1.715.425-.62.052-1.385.052-2.333.052H8.317c-.949 0-1.714 0-2.334-.052-.637-.05-1.197-.162-1.715-.425a4.375 4.375 0 0 1-1.913-1.913c-.264-.518-.373-1.078-.426-1.715-.05-.62-.05-1.384-.05-2.333v-8.19a.875.875 0 0 1 .45-.765l8.525-4.742c.04-.023.079-.045.118-.065.88-.49 1.487-.828 2.147-.964",
  fill: "#619F8E"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "14",
  cy: "9",
  r: "7",
  fill: "#FCBB2E"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "14",
  cy: "9",
  r: "5.833",
  fill: "#F3A700"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  d: "M16.674 6.083H15.17v5.834h1.503V6.084ZM13.178 10.002a1.86 1.86 0 0 0 1.692-2.015 1.86 1.86 0 0 0-1.692 2.015ZM12.878 6.083h-1.503v5.834h1.503V6.084Z",
  fill: "#FFE2A3"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_6))
}
export default { render: render }